import { useEffect } from "react";

export function useGlobalShortcuts() {

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      const target = event.target as HTMLElement | null;
      const isTyping =
        target &&
        (target.tagName === "INPUT" ||
          target.tagName === "TEXTAREA" ||
          target.isContentEditable);

      if (isTyping) return;

      switch (event.key) {
        case "F1":
          event.preventDefault();
          window.open(`/user/invoices/add`)
          break;

        case "F2":
          event.preventDefault();
          window.open(`/user/quotes/add`)
          break;

        default:
          break;
      }
    };

    window.addEventListener("keydown", onKeyDown);

    return () => {
      window.removeEventListener("keydown", onKeyDown);
    };
  }, []);
}